import { useState } from 'react'
import { useSelector } from 'react-redux'
import '../styles/Filters.css'
import { filterDropdown, priorityOptions, repairPriorityOptions, statusOptions, workOrderStatusFilterOptions } from '../utils/Dropdowns'
import { errorNotify } from '../utils/toast'
import Input from './input'
import Select from './Select'
import UserAvatar from './UserAvatar'

const Filters = ({ closeFilter, searchFilters, setSearchFilters, filterName, type, tagsOptions = [], setWrapperRef, removeFilter, component = null }) => {

    const { getIssueTagsDropdownData, getIssueTagsDropdownLoading } = useSelector((state) => state.issues);
    const { userDropdownData } = useSelector((state) => state.users);
    const { getAllPermissionsDropdown, getAllPermissionsLoading } = useSelector((state) => state.permissions);
    const { getVendorsDropdownData } = useSelector((state) => state.workOrder);

    let options = [
        { label: 'Contains', value: 'contains' },
        { label: 'Equals', value: 'equals' },
        { label: 'is One Of', value: 'one_of' }
    ]

    if (type === "date" || type === "number") {
        options = [
            { label: 'Equal To', value: 'equal_to' },
            { label: 'Less Than', value: 'less_than' },
            { label: 'Greater Than', value: 'greater_than' },
            { label: 'Less Than Equal To', value: 'less_than_equal_to' },
            { label: 'Greater Than Equal To', value: 'greater_than_equal_to' },
        ]
    }

    const [filterType, setFilterType] = useState(searchFilters?.[filterName]?.filter_type || '');
    const initialValue = filterType === 'one_of'
        ? searchFilters?.[filterName]?.value || []
        : searchFilters?.[filterName]?.value || '';

    const [inputValue, setInputValue] = useState(initialValue);

    const [selectedStatuses, setSelectedStatuses] = useState(
        Array.isArray(searchFilters?.[filterName]?.value) ? searchFilters[filterName].value : []
    );

    const [repairClassStatuses, setRepairClassStatuses] = useState(
        Array.isArray(searchFilters?.[filterName]?.value) ? searchFilters[filterName].value : []
    );

    const [vendorStatuses, setVendorStatuses] = useState(
        Array.isArray(searchFilters?.[filterName]?.value) ? searchFilters[filterName].value : []
    );

    const [financialStatuses, setFinancialStatuses] = useState(
        Array.isArray(searchFilters?.[filterName]?.value) ? searchFilters[filterName].value : []
    );

    const [operationalStatuses, setOperationalStatuses] = useState(
        Array.isArray(searchFilters?.[filterName]?.value) ? searchFilters[filterName].value : []
    );

    const [selectedUsers, setSelectedUsers] = useState(
        Array.isArray(searchFilters?.[filterName]?.value) ? searchFilters[filterName].value : []
    );

    const [selectedPriorities, setSelectedPriorities] = useState(
        Array.isArray(searchFilters?.[filterName]?.value) ? searchFilters[filterName].value : []
    );

    const [selectedPermissions, setSelectedPermissions] = useState(
        Array.isArray(searchFilters?.[filterName]?.value) ? searchFilters[filterName].value : []
    );

    const [selectedTags, setSelectedTags] = useState(
        Array.isArray(searchFilters?.[filterName]?.value) ? searchFilters[filterName].value : []
    );

    const filteredUserOptions = (userDropdownData || []).map(opt => ({
        ...opt,
        label: (
            <span style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                <UserAvatar username={opt.label} image={opt.image} />
                <span>{opt.label}</span>
            </span>
        ),
        labelKey: opt.label,
        value: opt.label
    }));

    const permissionOptions = (getAllPermissionsDropdown || []).map(opt => ({
        label: opt.badge,
        value: opt.badge
    }));

    const tagsDropdown = getIssueTagsDropdownData?.map(opt => ({
        label: opt.tag_name,
        value: opt.tag_name
    }));

    const vendorDropdown = getVendorsDropdownData?.map(opt => ({
        label: opt.title,
        value: opt.title
    }));

    const handleStatusApply = () => {
        if (selectedStatuses.length === 0) {
            removeFilter();
            closeFilter();
            return;
        }
        setSearchFilters(prev => ({
            ...prev,
            [filterName]: {
                filter_type: 'one_of',
                value: selectedStatuses
            }
        }));
        closeFilter();
    };

    const handleUserApply = () => {
        // const selectedLabels = (userDropdownData || [])
        //     .filter(opt => selectedUsers.includes(opt.value))
        //     .map(opt => opt.label);

        const selectedValues = selectedUsers

        if (selectedValues.length === 0) {
            removeFilter();
            closeFilter();
            return;
        }

        setSearchFilters(prev => ({
            ...prev,
            [filterName]: {
                filter_type: 'one_of',
                // value: selectedLabels
                value: selectedValues
            }
        }));
        closeFilter();
    };

    const handlePriorityApply = () => {
        if (selectedPriorities.length === 0) {
            removeFilter();
            closeFilter();
            return;
        }
        setSearchFilters(prev => ({
            ...prev,
            [filterName]: {
                filter_type: 'one_of',
                value: selectedPriorities
            }
        }));
        closeFilter();
    };

    const handleRepairApply = () => {
        if (repairClassStatuses.length === 0) {
            removeFilter();
            closeFilter();
            return;
        }
        setSearchFilters(prev => ({
            ...prev,
            [filterName]: {
                filter_type: 'one_of',
                value: repairClassStatuses
            }
        }));
        closeFilter();
    };

    const handleFinanceApply = () => {
        if (financialStatuses.length === 0) {
            removeFilter();
            closeFilter();
            return;
        }
        setSearchFilters(prev => ({
            ...prev,
            [filterName]: {
                filter_type: 'one_of',
                value: financialStatuses
            }
        }));
        closeFilter();
    };

    const handleVendorApply = () => {
        if (vendorStatuses.length === 0) {
            removeFilter();
            closeFilter();
            return;
        }
        setSearchFilters(prev => ({
            ...prev,
            [filterName]: {
                filter_type: 'one_of',
                value: vendorStatuses
            }
        }));
        closeFilter();
    };

    const handleOperationApply = () => {
        if (operationalStatuses.length === 0) {
            removeFilter();
            closeFilter();
            return;
        }
        setSearchFilters(prev => ({
            ...prev,
            [filterName]: {
                filter_type: 'one_of',
                value: operationalStatuses
            }
        }));
        closeFilter();
    };

    const handleTagsApply = () => {
        if (!selectedTags || selectedTags.length === 0) {
            removeFilter();
            closeFilter();
            return;
        }
        setSearchFilters(prev => ({
            ...prev,
            [filterName]: {
                filter_type: 'one_of',
                value: selectedTags
            }
        }));
        closeFilter();
    };

    const handlePermissionApply = () => {
        if (selectedPermissions.length === 0) {
            removeFilter();
            closeFilter();
            return;
        }

        setSearchFilters(prev => ({
            ...prev,
            [filterName]: {
                filter_type: 'one_of',
                value: selectedPermissions
            }
        }));
        closeFilter();
    }

    const handleApply = () => {
        // if (!filterType) {
        //     removeFilter();
        //     closeFilter();
        //     return;
        // }
        if (
            (filterType === 'one_of' && (!inputValue || inputValue.length === 0)) ||
            (!inputValue && filterType !== 'one_of')
        ) {
            errorNotify('Please enter a value for the filter.');
            return;
        }
        let valueToSave = inputValue;
        if (type === 'date' && typeof valueToSave === 'string') {
            valueToSave = valueToSave.slice(0, 10);
        }
        let finalValue;
        if (filterType === 'one_of') {
            finalValue = Array.isArray(valueToSave)
                ? valueToSave.map(v => typeof v === 'object' ? v.value : v)
                : [valueToSave];
        } else if (type === 'number') {
            finalValue = parseInt(valueToSave);
        } else {
            finalValue = valueToSave;
        }
        setSearchFilters(prev => ({
            ...prev,
            [filterName]: {
                filter_type: filterType,
                value: finalValue
            }
        }));
        closeFilter();
    };

    let inputField = null;
    if (filterName === 'statusFilter') {
        inputField = (
            <Select
                label="Status"
                placeholder="Select status(es)"
                options={component === "wordOrder" ? workOrderStatusFilterOptions : statusOptions}
                loading={false}
                name="status"
                value={component === "wordOrder" ? workOrderStatusFilterOptions.filter(opt => selectedStatuses.includes(opt.value)) : statusOptions.filter(opt => selectedStatuses.includes(opt.value))}
                onChange={vals => setSelectedStatuses(vals ? vals.map(v => v.value) : [])}
                isMulti={true}
                isSearch={true}
            />
        );
    }

    else if (filterName === 'vendorFilter') {
        inputField = (
            <Select
                label="Vendor"
                placeholder="Select Vendor(es)"
                options={vendorDropdown}
                loading={false}
                name="status"
                value={vendorDropdown.filter(opt => vendorStatuses.includes(opt.value))}
                onChange={vals => setVendorStatuses(vals ? vals.map(v => v.value) : [])}
                isMulti={true}
                isSearch={true}
            />
        );
    }

    else if (filterName === 'repairClassFilter') {
        inputField = (
            <Select
                label="Priority"
                placeholder="Select Priority(es)"
                options={repairPriorityOptions}
                loading={false}
                name="status"
                value={repairPriorityOptions.filter(opt => repairClassStatuses.includes(opt.value))}
                onChange={vals => setRepairClassStatuses(vals ? vals.map(v => v.value) : [])}
                isMulti={true}
                isSearch={true}
            />
        );
    }

    else if (filterName === 'financeStatusFilter') {
        inputField = (
            <Select
                label="Status"
                placeholder="Select Status(es)"
                options={filterDropdown}
                loading={false}
                name="status"
                value={filterDropdown.filter(opt => financialStatuses.includes(opt.value))}
                onChange={vals => setFinancialStatuses(vals ? vals.map(v => v.value) : [])}
                isMulti={true}
                isSearch={true}
            />
        );
    }

    else if (filterName === 'operationStatusFilter') {
        inputField = (
            <Select
                label="Status"
                placeholder="Select Status(es)"
                options={filterDropdown}
                loading={false}
                name="status"
                value={filterDropdown.filter(opt => operationalStatuses.includes(opt.value))}
                onChange={vals => setOperationalStatuses(vals ? vals.map(v => v.value) : [])}
                isMulti={true}
                isSearch={true}
            />
        );
    }

    else if (filterName === "permissionBadgeNameFilter") {
        inputField = (
            <Select
                label="Permission"
                placeholder="Select"
                options={permissionOptions}
                loading={getAllPermissionsLoading}
                name="priority"
                value={permissionOptions.filter(opt => selectedPermissions.includes(opt.value))}
                onChange={vals => setSelectedPermissions(vals ? vals.map(v => v.value) : [])}
                isMulti={true}
                isSearch={true}
            />
        );
    }
    else if (filterName === 'priorityFilter') {
        inputField = (
            <Select
                label="Priority"
                placeholder="Select priority(ies)"
                options={priorityOptions}
                loading={false}
                name="priority"
                value={priorityOptions.filter(opt => selectedPriorities.includes(opt.value))}
                onChange={vals => setSelectedPriorities(vals ? vals.map(v => v.value) : [])}
                isMulti={true}
                isSearch={true}
            />
        );
    }
    else if (filterName === 'reporterFilter' || filterName === 'assigneeFilter' || filterName === "issueByFilter") {
        inputField = (
            <Select
                label="User"
                placeholder="Select user(s)..."
                options={filteredUserOptions}
                loading={false}
                name="user"
                value={filteredUserOptions.filter(opt => selectedUsers.includes(opt.value || opt.labelKey))}
                onChange={vals => setSelectedUsers(vals ? vals.map(v => v.value) : [])}
                isMulti={true}
                isSearch={true}
            />
        );
    } else if (filterName === 'tagsFilter') {
        inputField = (
            <Select
                label="Tags"
                placeholder="Select tag(s)"
                options={tagsDropdown}
                loading={getIssueTagsDropdownLoading}
                name="tags"
                value={tagsDropdown?.filter(opt => selectedTags.includes(opt.value))}
                onChange={vals => setSelectedTags(vals ? vals.map(v => v.value) : [])}
                isMulti={true}
                isSearch={true}
            />
        );
    } else if (filterType === 'one_of') {
        inputField = (
            <Select
                label="Values"
                placeholder="Type and press Enter to create Values"
                options={[]}
                loading={false}
                name="values"
                value={inputValue}
                onChange={vals => setInputValue(vals)}
                isMulti={true}
                isCreatable={true}
            />
        );
    } else if (type === "date") {
        inputField = (
            <Input
                label="Date"
                placeholder="Select Date"
                type="date"
                name="value"
                value={inputValue}
                onChange={e => setInputValue(e.target.value)}
            />
        );
    } else {
        inputField = (
            <Input
                label="Search Text"
                placeholder="Search"
                type={type === "number" ? "number" : "text"}
                name="value"
                value={inputValue}
                onChange={e => setInputValue(e.target.value)}
            />
        );
    }

    return (
        <div className='filter_wrapper' ref={setWrapperRef}>
            {filterName !== 'statusFilter' && filterName !== 'tagsFilter' && filterName !== 'priorityFilter' &&
                filterName !== 'reporterFilter' && filterName !== 'permissionBadgeNameFilter' &&
                filterName !== 'assigneeFilter' && filterName !== 'repairClassFilter' && filterName !== 'operationStatusFilter' &&
                filterName !== 'financeStatusFilter' && filterName !== 'issueByFilter' && filterName !== 'vendorFilter' && (
                    <Select
                        label="Filter Operator"
                        placeholder="Select"
                        options={options}
                        loading={false}
                        name="filter_type"
                        value={options.find(opt => opt.value === filterType)}
                        onChange={opt => {
                            const newType = opt?.value || '';
                            setFilterType(newType);
                            if ((filterType === 'one_of' && newType !== 'one_of') || (filterType !== 'one_of' && newType === 'one_of')) {
                                setInputValue(newType === 'one_of' ? [] : '');
                            }
                        }}
                    />
                )}

            {inputField}

            <div className='filter_buttons'>
                <button onClick={closeFilter}>Cancel</button>
                {filterName === 'statusFilter' ? (
                    <button type="button" onClick={handleStatusApply}>Apply</button>
                ) : filterName === 'priorityFilter' ? (
                    <button type="button" onClick={handlePriorityApply}>Apply</button>
                ) : filterName === 'repairClassFilter' ? (
                    <button type="button" onClick={handleRepairApply}>Apply</button>
                ) : filterName === 'financeStatusFilter' ? (
                    <button type="button" onClick={handleFinanceApply}>Apply</button>
                ) : filterName === 'vendorFilter' ? (
                    <button type="button" onClick={handleVendorApply}>Apply</button>
                ) : filterName === 'operationStatusFilter' ? (
                    <button type="button" onClick={handleOperationApply}>Apply</button>
                ) : filterName === 'reporterFilter' || filterName === 'assigneeFilter' || filterName === "issueByFilter" ? (
                    <button type="button" onClick={handleUserApply}>Apply</button>
                ) : filterName === 'tagsFilter' ? (
                    <button type="button" onClick={handleTagsApply}>Apply</button>
                ) : filterName === 'permissionBadgeNameFilter' ? (
                    <button type="button" onClick={handlePermissionApply}>Apply</button>
                ) :
                    (
                        <button type="button" onClick={handleApply}>Apply</button>
                    )}
            </div>
        </div>
    )
}

export default Filters